import { useEffect, useRef } from "react";
import { useElementId } from "../../utils/useElementId";

export function useFormControlId(id: string, formControl?: any) {
    const wrapperId = useElementId(id);
    const controlId = useRef(`${wrapperId.current}_ctrl`);
    useEffect(() => {
        if (formControl) {
            formControl.id = controlId.current;
            formControl.update();
        }
    }, [formControl]);

    return {
        wrapperId: wrapperId.current,
        controlId: controlId.current
    };
}
